import { defineMessages } from 'react-intl';

import { sharedMessages } from '@app/translations';

export const messages = {
  ...defineMessages({
    success: {
      id: 'projects.itemWasAddedToProject',
      defaultMessage: 'Added to your project.',
    },
  }),
  error: sharedMessages.somethingWentWrongPleaseTryAgain,
};
